"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getStateStyles = function getStateStyles(stateValues, borderColor, backgroundColor) {
  var stateStyles = Object.keys(stateValues).reduce(function (_styles, stateKey) {
    return _objectSpread(_objectSpread({}, _styles), {}, (0, _defineProperty2.default)({}, ":".concat(stateKey), stateValues[stateKey]));
  }, {});
  stateStyles[':focus'] = _objectSpread(_objectSpread({}, stateStyles[':focus']), (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, borderColor, {
    color: backgroundColor,
    width: 1
  }).focus);
  return stateStyles;
};

var variantStyles = function variantStyles(_ref, theme) {
  var colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      iconOnly = _ref.iconOnly,
      isDestructive = _ref.isDestructive,
      size = _ref.size,
      variant = _ref.variant;
  var selectors = theme.selectors;
  var isTertiary = variant === _interfaces.ButtonVariant.Tertiary;
  var hasDarkBackground = colorScheme === _interfaces.ButtonColorScheme.DarkBackground;

  var getColor = function getColor(colorKey) {
    return selectors.color(colorKey);
  };

  var fillGap = {
    color: getColor(hasDarkBackground ? 'neutral90' : 'neutral0'),
    width: 1
  };
  var backgroundColor = '';
  var color = '';
  var styles = {
    borderColor: 'transparent'
  };
  var stateStyles = {};

  if (iconOnly) {
    styles.minWidth = "".concat(_utils.A11Y_MIN_SIZE, "px");
  } else if (!isTertiary) {
    styles.minWidth = "".concat(size === _interfaces.ButtonSize.Small ? _constants.SMALL_BUTTON_WIDTH : _constants.REGULAR_BUTTON_WIDTH, "px");
  }

  if (disabled) {
    color = getColor('neutral70');

    if (isTertiary) {
      backgroundColor = getColor('neutral0');
      stateStyles = {
        ':focus': {
          outline: 'none',
          borderColor: color
        }
      };
    } else {
      backgroundColor = getColor('neutral10');
      styles.borderColor = color;
      stateStyles = {
        ':focus': _objectSpread({}, (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, color, fillGap).focus)
      };
    }
  } else {
    var colorBase = isDestructive ? 'red' : 'primary';

    switch (variant) {
      case _interfaces.ButtonVariant.Primary:
        backgroundColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '70'));
        color = getColor("neutral".concat(hasDarkBackground ? '100' : '0'));
        var primaryActiveBackgroundColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '50' : '80'));
        stateStyles = getStateStyles({
          active: {
            backgroundColor: primaryActiveBackgroundColor
          },
          focus: {
            backgroundColor: primaryActiveBackgroundColor
          },
          hover: {
            backgroundColor: getColor("".concat(colorBase).concat(hasDarkBackground ? '30' : '60'))
          }
        }, primaryActiveBackgroundColor, color);
        break;

      case _interfaces.ButtonVariant.Tertiary:
        backgroundColor = 'transparent';
        color = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '60'));
        var borderColor = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '70'));
        stateStyles = getStateStyles({
          active: {
            borderColor: color
          },
          focus: {
            borderColor: borderColor
          },
          hover: {
            borderColor: color
          }
        }, borderColor, backgroundColor);
        break;

      case _interfaces.ButtonVariant.Secondary:
      default:
        backgroundColor = getColor("neutral".concat(hasDarkBackground ? '100' : '0'));
        color = getColor("".concat(colorBase).concat(hasDarkBackground ? '40' : '70'));
        stateStyles = getStateStyles({
          active: {
            backgroundColor: getColor("neutral".concat(hasDarkBackground ? isDestructive ? '90' : '80' : '10'))
          },
          focus: {
            backgroundColor: getColor("".concat(colorBase).concat(hasDarkBackground ? '80' : '05'))
          },
          hover: {
            backgroundColor: getColor("".concat(colorBase).concat(hasDarkBackground ? '90' : '05'))
          }
        }, color, backgroundColor);
        styles.borderColor = color;
        break;
    }
  }

  return _objectSpread(_objectSpread(_objectSpread({}, styles), stateStyles), {}, {
    backgroundColor: backgroundColor,
    color: color
  });
};

exports.variantStyles = variantStyles;